import storageService from '@/state/services/Storage'
import { setApiLanguage } from '@/state/services/Api'
import permissionService, { definePermissionsFor } from '@/state/services/Permission'
import i18n from '@/i18n'

function bootStore() {
  return (store) => {
    //Initial Setup
    const browserLang = navigator.language || navigator.userLanguage
    const locale = storageService.getLocale() || browserLang.substring(0, 2)
    bootLocale(locale)
    if (store.getters['auth/isAuthenticated']) {
      bootPermissions(store.getters['auth/currentUser'])
      bootApi(store)
    }

    store.subscribe((mutation) => {
      if (mutation.type === 'app/CHANGE_LOCALE') {
        bootLocale(mutation.payload)
      }
      if (mutation.type === 'auth/SET_CURRENT_USER') {
        bootPermissions(mutation.payload)
        bootApi(store)
      }
      if (mutation.type === 'auth/PURGE_AUTH') {
        bootPermissions(null)
      }
    })
  }
}

function bootLocale(locale) {
  storageService.saveLocale(locale)
  i18n.loadLanguageAsync(locale)
  setApiLanguage(locale)
}

function bootPermissions(user) {
  permissionService.update(definePermissionsFor(user))
}

function bootApi(store) {
  Promise.all([
    store.dispatch('devices/getTypes'),
    store.dispatch('companies/getAll'),
    //store.dispatch('users/getGroups'),
    //store.dispatch('users/getRoles'),
  ])
}

const bootPlugin = bootStore()

export default bootPlugin
